import styled from 'styled-components';
import { BaseCell } from 'core/table/BaseCell';

const StyledInput = styled.input`
  && {
    margin-right: 10px;
  }
  cursor: pointer;
  user-select: none;
  width: 15px;
  height: 15px;
`;

// type RadioCellProps = {
//   checked: Boolean,
//   id: string,
//   label: string,
//   name: string,
//   onChange: () => {},
//   value: string,
// };

const createRadioCell =
  (useBaseCell /*: boolean */) =>
  ({ checked, id, name = 'radio-group', onChange, value }) => {
    const Cell = (
      <StyledInput
        checked={checked}
        id={id}
        type="radio"
        name={name}
        value={value}
        data-test={`radio-${id}`}
        onChange={onChange}
      />
    );

    if (useBaseCell) {
      return <BaseCell>{Cell}</BaseCell>;
    }
    return Cell;
  };

export const RadioCell = createRadioCell(true);
export const CleanRadioCell = createRadioCell(false);
